import Alert from "../Alert/Alert"
import { AddItemAlertProps } from "./AddItemAlert.types"
import Button from "../Button/Button"
import PlusIcon from "../../media/PlusIcon"
import "./AddItemAlert.css"

const AddItemAlert = (props: AddItemAlertProps) => {

  const {
    show,
    title,
    input,
    onHide,
    onSubmit
  } = props

  const submitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <Alert showAlert={show} onClose={onHide}>
      <form className="add-item-alert-form" onSubmit={submitForm}>
        <div className="add-item-header">
          <h2>{title}</h2>
          <div className="close-add-item-header" onClick={() => onHide()}>
            <PlusIcon />
          </div>
        </div>

        <input
          className="add-item-input"
          type="text"
          value={input.value}
          onChange={(e) => input.onChange(e.target.value)}
          placeholder={input.placeholder}
        />
        <Button className="add-item-button" title="Done" onClick={onSubmit} type="full" />

      </form>
    </Alert>
  )
}

export default AddItemAlert